var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-new": false,
          "show-print": false,
          "show-delete": false,
          "show-save": _vm.isSaveButton,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _c("bank-undeposited-fund-side-menu", {
              on: { filter: _vm.filterList, reset: _vm.resetList },
              model: {
                value: _vm.filter,
                callback: function ($$v) {
                  _vm.filter = $$v
                },
                expression: "filter",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column" },
          [
            _vm.entity
              ? _c("router-view", {
                  key: _vm.$route.fullPath,
                  ref: "currentChild",
                  attrs: {
                    "is-tiled": false,
                    "route-name": _vm.$route.name,
                    filter: _vm.filter,
                    entity: _vm.entity,
                    "is-save": _vm.isSave,
                  },
                  model: {
                    value: _vm.selectedItems,
                    callback: function ($$v) {
                      _vm.selectedItems = $$v
                    },
                    expression: "selectedItems",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "confirm-modal",
        {
          attrs: {
            active: _vm.isConfirmModalActive,
            "ok-text": "Save & Print",
            "cancel-text": "Print",
            "close-text": "Close",
            "show-close": true,
          },
          on: {
            "update:active": function ($event) {
              _vm.isConfirmModalActive = $event
            },
            ok: function ($event) {
              return _vm.saveEntity("ok")
            },
            cancel: function ($event) {
              return _vm.saveEntity("print")
            },
            close: function ($event) {
              return _vm.saveEntity("close")
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Do you want to Save and Print?"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v(
              " This will save your selected Bank Un-deposited Funds and Print. "
            ),
          ]),
        ]
      ),
      _c(
        "unsaved-modal",
        {
          attrs: { active: _vm.isUnsavedModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isUnsavedModalActive = $event
            },
            close: function ($event) {
              return _vm.closeModal()
            },
            skipSave: function ($event) {
              return _vm.skipSave()
            },
            saveContinue: function ($event) {
              return _vm.saveContinue()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Unsaved Changes"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v("There are unsaved changes. Please select action below"),
          ]),
        ]
      ),
      _c(
        "save-conflict-modal",
        {
          attrs: { active: _vm.isSaveConflictModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isSaveConflictModalActive = $event
            },
            close: function ($event) {
              return _vm.closeModal()
            },
            reload: function ($event) {
              return _vm.reloadData()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Change conflict"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v(
              "The data on the server is newer than the local copy. Please reload local data."
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }